import { isNumber as _isNumber } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { translator } from 'mage-i18n';
import { SpacerVertical, ListPrimary, Typography } from '@klarna/bubble-ui';

import { ContainerTemplate } from '@/components';
import { getMerchantError } from '@/selectors/merchant';

const tPrefix = 'products-fe.containers.wrong_prefill_data';

const getErrorMessage = (t, { path: errorPath = [], message }) => {
  const path = Array.isArray(errorPath) ? errorPath : Object.values(errorPath);
  // If it's an element on an array, we don't need to know the exact position
  const fieldKeyPath = path.map(p => (_isNumber(p) ? 'item' : p)).join('_');
  // We only need to map the index on the first level
  const index = path[1];
  const fieldKeyText =
    t(`${tPrefix}.fields.${fieldKeyPath}`, { ...(index !== undefined ? { index } : {}) }) ||
    fieldKeyPath;

  if (!message) {
    return `${fieldKeyText} ${t(`${tPrefix}.error_types.fallback`)}`;
  }

  // Joi messages are a bit odd
  if (path.length >= 1 && message.indexOf(`"${path[path.length - 1]}"`) !== -1) {
    return message.replace(`"${path[path.length - 1]}"`, fieldKeyText);
  } else if (path.length >= 2 && message.indexOf(`"${path[path.length - 2]}"`) !== -1) {
    return message.replace(`"${path[path.length - 2]}"`, fieldKeyText);
  } else {
    return `${fieldKeyText} ${message}`;
  }
};

export const PreAssessmentWrongPrefillData = ({ error, t }) => {
  const errorDetails = Array.isArray(error.details)
    ? error.details
    : Object.values(error.details) || [];
  return (
    <ContainerTemplate
      title={t(`${tPrefix}.title`)}
      subtitle={t(`${tPrefix}.subtitle`)}
      error={error}
    >
      <SpacerVertical small />
      <Typography textToken="text-style/headings/titles/bold/grande">
        {t(`${tPrefix}.details`)}
      </Typography>
      <ListPrimary items={errorDetails.map(e => getErrorMessage(t, e))} />
    </ContainerTemplate>
  );
};

PreAssessmentWrongPrefillData.propTypes = {
  error: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect(state => ({
  error: getMerchantError(state),
  t: translator(state),
}))(PreAssessmentWrongPrefillData);
